package horcrux.frontend.common.views.feedbackform

import arrow.core.toOption
import horcrux.common.api.dtos.types.UserFeedback
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.State
import js.objects.jso
import mui.material.AlertColor
import mui.material.Button
import mui.material.ButtonVariant
import react.FC
import react.Props
import react.router.NavigateFunction
import web.cssom.pct

external interface FeedbackFormAndSubmitProps : Props {
    var feedbackType: FeedbackType
    var globalAppState: GlobalAppState
    var navigate: NavigateFunction
}

fun UserFeedbackMaybeState.submitIfValid(
    navigate: NavigateFunction,
    globalAppState: GlobalAppState,
    onSuccess: () -> Unit = {}
) =
    this
        .get()
        .toOption()
        .filter { it.isValid() }
        .map { userFeedback ->
            globalAppState.submitBackendAPIRequestAsync { backendClient ->
                backendClient
                    .submitFeedback(userFeedback)
                    .map {
                        globalAppState.updateBanner(AlertColor.success, "Your feedback has been submitted!")
                        onSuccess()
                    }
                    .bind()
            }
        }

val FeedbackFormAndSubmit = FC<FeedbackFormAndSubmitProps> { props ->
    val userFeedbackMaybeState = State<UserFeedback?>(null)
    FeedbackForm {
        this.userFeedbackMaybeState = userFeedbackMaybeState
        this.feedbackType = props.feedbackType
    }

    Button {
        +"Submit"
        this.id = "submit-user-feedback"
        this.variant = ButtonVariant.contained
        this.style = jso {
            this.maxWidth = 25.pct
        }
        this.onClick = {
            userFeedbackMaybeState.submitIfValid(props.navigate, props.globalAppState) {
                userFeedbackMaybeState.reset()
            }
        }
    }
}
